import { ongoingShortOf } from "@genbaryoku/contract";
import { useLabels } from "../labels.js";
import { useUses } from "../core/uses.js";

/**
 * 継続案件（#289、docs/101）の画面の判定と言葉。on＝会社の使う機能「{ongoingProject}」がオン（オフの会社は画面が今までと同じ）、
 * word＝{ongoingProject}（継続案件／現場／契約…）、short＝札・タブ・区切りの短い形（「継続案件」→「継続」）
 */
export function useOngoing(): { on: boolean; word: string; short: string } {
  const L = useLabels();
  const has = useUses();
  return { on: has("ongoingProjects"), word: L.ongoingProject, short: ongoingShortOf(L) };
}

/** 決まり文の {ongoingShort} を短い形に（{ongoingProject} などの言葉は t() が埋める） */
export const withShort = (text: string, short: string): string => text.replaceAll("{ongoingShort}", short);
